import * as React from "react";
import { Elevate } from "../components/elevate";
import { FiveStarRated } from "../components/five-star-rated";
import HeroBgLeft from "../images/home/hero-bg-left.png";
import HeroBgRight from "../images/home/hero-bg-right.png";

import { Hero } from "../components/hero";
import { OurWhiteLabel } from "../components/our-white-label";
import { Services } from "../components/home/services";
import { TrustedBy } from "../components/trusted-by";
import { Layout } from "../layouts";
import { ratedFeatures, trustedByEntities } from "../contents";

const IndexPage = () => (
  <Layout
    title="White Label SEO, PPC, & Facebook Ads for Agencies | 100% USA-Based"
    description="100% USA-based white label SEO, PPC, and Facebook Ads management for ambitious agency owners. Get our pricing and schedule your free consultation now!"
  >
    <Hero
      title="White Label SEO, PPC, Facebook Ads, &&nbsp;TikTok Ads to Grow Your Agency&nbsp;Faster"
      text="Successful agencies work with Agency Elevation to elevate their growth and profitability."
      bgLeft={HeroBgLeft}
      bgRight={HeroBgRight}
      isRenderedOnHome={true}
    />
    <TrustedBy trustedByEntities={trustedByEntities} />
    <FiveStarRated features={ratedFeatures} />
    <Services />
    <OurWhiteLabel title={<>Our White Label Services Are a No-Brainer</>} />
    <Elevate />
  </Layout>
);

export default IndexPage;
